// components
import { Container } from '@/components/Grid';

// styles
import {
  IntroductionTextWrapper,
  Title,
  Content,
} from './IntroductionText.styles';

export function IntroductionText() {
  return (
    <IntroductionTextWrapper>
      <Container>
        <Title>
          Schedule, track, and measure performance
          <br /> for every dock appointment
        </Title>
        <Content>
          Schedule your dock appointments online. No more phone calls, emails,
          and spreadsheets. Facilities using Opendock experience shorter truck
          dwell times, fewer detention fees, and less labor spent on scheduling.
        </Content>
      </Container>
    </IntroductionTextWrapper>
  );
}
